<template>
  <section class="f-35">
    <div class="alive_content f-select-center" ref="content">
      <div>
        <div class="title f-center-title">
          <div>Aicy 卡片</div>
          <div>一键展开更便捷</div>
        </div>
        <div class="des f-center-sub-title">
          无需进入应用，也能选歌听歌、查看车辆状态、调节座椅设置等，精简操作时的步骤
        </div>
        <div class="alive_control">
          <div
            v-for="(i, index) in controlList"
            class="control_item"
            :class="index === activeIndex && 'control_item_active'"
            @click="controlClick(i.url, index)"
          >
            {{ i.title }}
          </div>
        </div>
      </div>
      <div class="slider_container" v-ia>
        <div class="slider_size border_container_light">
          <!-- <m-img :src="controlList[activeIndex].url" /> -->
          <slider
            ref="slider"
            v-model:value="activeIndex"
            :controlBtn="false"
            :indicators="false"
            :interval="3000"
            :autoplay="autoplay"
            :touch="false"
            stopOnHover
            height="100%"
            width="100%"
          >
            <slider-item v-for="(i, index) in controlList" :key="index">
              <m-img :src="i.url" />
            </slider-item>
          </slider>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { replayVideo } from '@/utils'
import replay from '@/components/replay.vue'
export default {
  components: {
    replay,
  },
  data() {
    return {
      preload_: true,
      activeIndex: 0,
      autoplay: false,
      controlList: [
        {
          title: '音乐推荐',
          url: require('@/v2/auto/assets/image/35/0.jpg'),
        },
        {
          title: '座椅按摩',
          url: require('@/v2/auto/assets/image/35/1.jpg'),
        },
        {
          title: '胎压',
          url: require('@/v2/auto/assets/image/35/2.jpg'),
        },
        {
          title: '能耗',
          url: require('@/v2/auto/assets/image/35/3.jpg'),
        },
      ],
    }
  },
  mounted() {
    this.$gsap.timeline({
      scrollTrigger: {
        trigger: this.$refs.content,
        // markers: true,
        onUpdate: (self) => {
          if (!self.isActive) {
            this.activeIndex = 0
          }
          this.autoplay = self.isActive
          this.$refs.slider.auto()
        },
      },
    })
  },
  methods: {
    replayVideo,
    controlClick(url, index) {
      this.activeIndex = index
    },
  },
}
</script>
<style lang="less" scoped>
.f-35 {
  width: 100%;
  position: sticky;
  overflow: hidden;
  z-index: 79;
  display: flex;
  justify-content: center;
  align-items: center;
  .alive_content {
    display: flex;
    align-items: center;
    height: 1100px;
    .title {
      display: flex;
      flex-direction: column;
      width: max-content;
      line-height: 1.4;
      // 设置背景
      background: radial-gradient(
        120.01% 677.74% at 1.57% 10.13%,
        #2e63ca 0%,
        #91a8e4 100%
      );
      // 背景作用于字体上
      background-clip: text;
      // 字体透明
      color: transparent;
      font-weight: 700;
    }
    .des {
      margin: 20px 0;
      line-height: 22px;
      color: #00000080;
      line-height: 1.6;
      width: 400px;
    }
    .slider_container {
      margin-left: 150px;
      width: 1220px;
      height: 770px;
      @media screen and (max-width: 1920px) {
        width: 1020px;
        height: 645px;
      }
      @media screen and (max-width: 1680px) {
        width: 900px;
        height: 570px;
      }
      .slider_size {
        width: 1200px;
        height: 750px;
        @media screen and (max-width: 1920px) {
          width: 1000px;
          height: 625px;
        }
        @media screen and (max-width: 1680px) {
          width: 880px;
          height: 550px;
        }
      }
      img {
        border-radius: 20px;
        height: 100%;
        object-fit: cover;
        object-position: center;
      }
    }
    .alive_control {
      margin-top: 30px;
      border-radius: 100px;
      background-color: #f4f4f5;
      padding: 8px;
      height: max-content;
      display: flex;
      width: max-content;
      gap: 10px;
      .control_item {
        cursor: pointer;
        font-size: 16px;
        border-radius: 100px;
        display: flex;
        align-items: center;
        width: max-content;
        padding: 0 16px;
        height: 35px;
        color: #00000080;
      }
      .control_item_active {
        color: black;
        font-weight: 600;
        background-color: white;
      }
    }
  }
}
</style>
